import { useQuery } from "@tanstack/react-query";
import { getEditorAvailability, getEditorDocument } from "./api";
import type { EditorDocKind } from "./types";

/** Czy pokazywać przyciski „Edytuj w przeglądarce" (edytor skonfigurowany na serwerze). */
export const useEditorAvailability = () =>
  useQuery({
    queryKey: ["doc-editor", "availability"] as const,
    queryFn: getEditorAvailability,
    staleTime: 10 * 60_000,
  });

export const useEditorDocument = (kind: EditorDocKind | null, id: string | null) =>
  useQuery({
    queryKey: ["doc-editor", "document", kind, id] as const,
    queryFn: () => getEditorDocument(kind!, id!),
    enabled: !!kind && !!id,
  });
